import React from "react"

function Logo(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 449.33 311.12"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={30.66}
          y1={859.35}
          x2={410.17}
          y2={859.35}
          gradientTransform="translate(0 -748)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#a00" />
          <stop offset={0.5} stopColor="#e30000" />
          <stop offset={1} stopColor="#ff3232" />
        </linearGradient>
        <style>
          {".prefix__cls-1{fill:#052879;stroke:#052879;stroke-miterlimit:10}"}
        </style>
      </defs>
      <g id="prefix__Layer_2" data-name="Layer 2">
        <g id="prefix__Layer_1-2" data-name="Layer 1">
          <g id="prefix__Layer_2-2" data-name="Layer 2-2">
            <g id="prefix__Layer_1-2-2" data-name="Layer 1-2-2">
              <path
                className="prefix__cls-1"
                d="M250.07 21v88.9c-8.47 6.27-16.28 11.7-23.41 16.52a450 450 0 01-41.13 25.45h-74.35v29.6a132.34 132.34 0 01-31.08 4c-1 0-2 0-3.08-.05a46.89 46.89 0 01-14.8-2.48V21h46v86h93.65V21zM250.07 173v71.45h-48.89v-42.72A562.91 562.91 0 00250.07 173zM111.09 230v15H62.18v-19.81c9.54 3.48 20.64 5.3 33.52 5.52h.15c5.15-.01 10.21-.26 15.24-.71zM416.68 195.46v49H270.83V159.3c15.68-10.74 31.63-22.73 48.24-36.28v72.44zM319.07 21v29.42C301.43 67.83 285.35 82 270.83 93.78V21z"
              />
              <path
                d="M46.77 135.22a.11.11 0 00-.09-.13h-.08c-22.52 19.22-20.57 55.09 2 73.44 13.15 10.71 30.75 13.89 47.28 14.17 56.78-.14 107.5-28.64 157.33-61.26 44.23-28.61 85.64-64.13 125.9-102.44a.1.1 0 01.14 0L399 77.8a.1.1 0 00.14 0 .06.06 0 000-.06l11-77.62a.1.1 0 00-.09-.12l-75.68 19.92a.12.12 0 000 .14L348.1 31.9a.1.1 0 010 .14c-45.45 48.64-82.42 77.67-116.89 101-42.36 29.27-75.43 43.47-105.47 52.75-15.83 4.89-32.36 8.17-49 7.68-13-.39-27.84-4-33-17.5-5.03-12.97-1.08-28.24 3.03-40.75z"
                fill="url(#prefix__linear-gradient)"
              />
            </g>
          </g>
          <g
            style={{
              isolation: "isolate",
            }}
          >
            <path d="M26.87 275.59v34.83h-8v-13.83H8v13.83H0v-34.83h8v13.33h11v-13.33zM53.24 305H40.3l-1.74 5.47h-8.7l11.84-34.88h10.15l11.84 34.83H55zm-2.39-7.47l-4.08-12.79-4.08 12.79zM64.19 302.51l6.87-4a7.29 7.29 0 007.31 4.82c3.78 0 4.73-1.49 4.73-2.83 0-2.14-2-3-7.22-4.43s-10.25-3.93-10.25-10.6 5.68-10.6 11.7-10.6a13.5 13.5 0 0112.73 7.86l-6.71 3.93c-1.2-2.48-2.84-4-6-4-2.49 0-3.74 1.25-3.74 2.64 0 1.59.85 2.69 6.27 4.33s11.2 3.43 11.2 10.8c0 6.72-5.37 10.7-12.94 10.7-7.33-.01-12.01-3.5-13.95-8.62zM115.19 302.76v7.66h-20.4v-34.83h8v27.17zM140.07 305h-12.93l-1.75 5.47h-8.7l11.84-34.83h10.15l11.84 34.83h-8.71zm-2.39-7.47l-4.08-12.79-4.08 12.79zM188.34 310.42h-8v-20.25l-9 14.78h-.89l-9-14.78v20.25h-8v-34.83h8l9.45 15.47 9.46-15.47h8zM227.15 302.76v7.66h-20.4v-34.83h8v27.17zM227.15 293a18.12 18.12 0 1118.11 18.12A18 18 0 01227.15 293zm28.27 0a10.16 10.16 0 10-10.16 10.35A9.91 9.91 0 00255.42 293z" />
            <path d="M302.34 294c0 10.65-7.42 17.12-17.17 17.12-10.95 0-18.81-8.06-18.81-18.07a18.06 18.06 0 0118.26-18.16 17.83 17.83 0 0115.23 8l-6.77 3.88c-1.44-2.28-4.58-4.08-8.5-4.08a10 10 0 00-10.26 10.45c0 5.93 4.18 10.25 10.95 10.25 4.63 0 7.66-2 8.91-5.37h-9.31v-7h17.47zM314.78 275.59v34.83h-8v-34.83zM318.51 302.51l6.87-4a7.29 7.29 0 007.31 4.82c3.78 0 4.73-1.49 4.73-2.83 0-2.14-2-3-7.22-4.43s-10.2-3.91-10.2-10.58 5.68-10.6 11.7-10.6a13.52 13.52 0 0112.74 7.86l-6.72 3.93c-1.2-2.48-2.84-4-6-4-2.49 0-3.73 1.25-3.73 2.64 0 1.59.84 2.69 6.26 4.33s11.2 3.43 11.2 10.8c0 6.72-5.37 10.7-12.94 10.7-7.38-.03-12.06-3.52-14-8.64zM371.5 283.25h-8.95v27.17h-8v-27.17h-9v-7.66h25.95zM383 275.59v34.83h-8v-34.83zM387.43 293a17.65 17.65 0 0118.11-18.11 17.39 17.39 0 0114.93 8.11l-6.87 4a9 9 0 00-8.06-4.28c-6.17 0-10.15 4.13-10.15 10.35s4 10.35 10.15 10.35a9 9 0 008.06-4.27l6.87 4a17.27 17.27 0 01-14.93 8.06A17.66 17.66 0 01387.43 293zM422.46 302.51l6.87-4a7.29 7.29 0 007.31 4.82c3.78 0 4.73-1.49 4.73-2.83 0-2.14-2-3-7.22-4.43s-10.25-3.93-10.25-10.6 5.68-10.6 11.7-10.6a13.5 13.5 0 0112.73 7.86l-6.71 3.93c-1.2-2.48-2.84-4-6-4-2.49 0-3.74 1.25-3.74 2.64 0 1.59.85 2.69 6.27 4.33s11.2 3.43 11.2 10.8c0 6.72-5.37 10.7-12.94 10.7-7.33-.01-12.01-3.5-13.95-8.62z" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Logo
